import { Component } from '@angular/core';

@Component({
  selector: 'ca-impersonation-terms',
  standalone: true,
  template: `
    <p class="mb-3">
      By clicking the link to authorize S&P Global Inc.'s subsidiaries (collectively, the "S&P Entities") that publish
      and/or distribute and/or support the Services ("S&P Services") and in particular identified employees of S&P
      Entities ("S&P Support Staff") to conduct support tasks specified in writing by you ("Specified Tasks") in respect
      of your user account on the S&P Service ("User Account") by direct remote access ("Remote User Account Access") to
      your User Account, and in consideration of the S&P Entities and their employees trying to conduct such Specified
      Tasks you ("You" or "Your" as the case may be) hereby agree to the following terms and conditions ("T&Cs") that:
    </p>

    <p class="mb-3">
      1. S&P Support Staff can access, review, examine, and track Your User Account, and all content residing within
      and/or uploaded to Your User Account on the S&P Service by remote connection or other methods as determined by S&P
      Entities necessary to resolve the Specified Tasks ("Remote User Account Access") during the Assistance Period
      (defined below). If requested in the Specified Tasks, the S&P Support Staff may upload additional data as
      requested or my use the content to provide other S&P services to Your employer.
    </p>

    <p class="mb-3">
      2. You provide one or more S&P Support Staff with access to and control of (1) Your User Account (2) the settings
      and set up of Your User Account and (3) files and information that reside on or can be viewed or accessed through
      Your User Account as required for the Assistance Period to complete the Specified Tasks.
    </p>

    <p class="mb-3">
      3. The default Assistance Period runs until 5pm in New York on the fifth New York business day after You request
      Remote Access, unless You agree a longer or shorter period by e-mail exchange with the S&P Support Staff and
      subject to Section 11 below.
    </p>

    <p class="mb-3">
      4. This Remote User Account Access option is provided to You at Your and Your employer's sole risk and may give
      access to S&P Support Staff to confidential information accessible or visible upon or through Your User Account.
    </p>

    <p class="mb-3">
      5. You shall not make accessible or visible to any S&amp;P Support Staff in the conduct of the Specified Tasks any
      information which (A) should not be so disclosed to them by reason of any applicable law or regulation (B) makes
      them or is likely to make them an insider to any transaction or potential transaction in securities or (C) makes
      any S&amp;P Entities or any S&amp;P Support Staff a processor of personal data.
    </p>

    <p class="mb-3">
      6. You accept responsibility for any changes made to the desktop content or system settings of Your User Account
      by Remote User Account Access.
    </p>

    <p class="mb-3">
      7. You shall remain available by telephone and/or e-mail to the S&amp;P Support Staff throughout your normal
      working hours during the Assistance Period in order to log on to Your User Account and view the result of the work
      undertaken upon the Specified Tasks in order to provide Your timely opinion upon whether such result meet your
      needs.
    </p>

    <p class="mb-3">
      8. S&P Entities will not be held responsible for any data loss arising from conduct of (or attempts to conduct)
      the Specified Tasks, if any occur during or after Remote User Account Access. S&amp;P Entities cannot and does not
      guarantee that Remote User Account Access and attempts to conduct the Specified Tasks will (1) resolve Your stated
      issue or (2) not cause other or additional issues.
    </p>

    <p class="mb-3">
      9. THE LIABILITY OF ANY S&amp;P ENTITIES AND ANY OF S&amp;P ENTITIES' THIRD-PARTY PROVIDERS IN RESPECT OF REMOTE
      USER ACCOUNT ACCESS AND ATTEMPTS TO UNDERTAKE THE SPECIFIED TASKS SHALL BE LIMITED AS SPECIFICALLY SET FORTH IN
      YOUR OR YOUR EMPLOYER'S SUBSCRIPTION AGREEMENT FOR THE S&amp;P SERVICE. NOTWITHSTANDING ANYTHING TO THE CONTRARY
      HEREIN OR IN YOUR OR YOUR EMPLOYER'S SUBSCRIPTION AGREEMENT, S&amp;P ENTITIES SHALL NOT BE RESPONSIBLE OR LIABLE
      FOR ANY HARM THAT YOU OR ANY PERSON MAY SUFFER AS THE RESULT OF A BREACH OF CONFIDENTIALITY WITH RESPECT TO
      INFORMATION TRANSMITTED DURING REMOTE USER ACCOUNT ACCESS.
    </p>

    <p class="mb-3">
      10. In the event of a conflict between these T&amp;Cs and any other agreement You or Your employer may have with
      S&amp;P Entities, these T&amp;Cs shall prevail in respect of the Remote User Account Access and any attempts
      (successful or not) to undertake the Specified Tasks. These T&amp;Cs supersede and override any other
      understanding, oral or written, regarding this subject matter.
    </p>

    <p class="mb-3">
      11. You are entitled to terminate Remote User Account Access at any time by e-mail notice to the S&amp;P Support
      Staff assigned with the Specified Tasks. Otherwise, Remote User Account Access will terminate automatically at the
      end of the Assistance Period.
    </p>

    <p class="mb-3">
      12. You represent and warrant to the S&amp;P Entities that you are an Authorized User and that You have the
      capacity and authority to bind Yourself and Your employer, as applicable to these T&amp;Cs and that you have read
      them carefully and understand them.
    </p>
  `
})
export class ImpersonationTermsComponent {}
